import React from 'react';

//This can be used as a template to other menu options

const Two = (props) => {
  return (
    <div className="main-wrapper fade-in">
        <div>Two</div>
    </div>
  )
}

export default Two;